import React, { useCallback, useEffect, useState } from "react";
import Layout from "../../common/Layout";
import { useDispatch, useSelector } from "react-redux";
import ReactSelect from "react-select";
import { GetDataWithToken, PostDataWithToken } from "../../constants/ApiHelper";
import { FaPlus } from "react-icons/fa";
import _ from "lodash";
import { toast } from "react-toastify";
import { dispatchMmvData } from "../../store/actions/userActions";
import ReactPaginate from "react-paginate";
import { ImTab } from "react-icons/im";

const AddPrevInsurer = () => {
    const dispatch = useDispatch();

    const mmvData = useSelector((state) => state?.root?.mmvData);

    const [loading, setLoading] = useState(false);
    const [addNewRto, setAddNewRto] = useState(false)
    const [partnerRtoData, setPartnerRtoData] = useState([])

    const [stateData, setStateData] = useState([]);
    const [cityData, setCityData] = useState([]);
    const [rtoData, setRtoData] = useState([]);

    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedRto, setSelectedRto] = useState(null);

    const [stateId, setStateId] = useState("");
    const [cityId, setCityId] = useState("");

    const [stateModal, setStateModal] = useState(false);
    const [cityModal, setCityModal] = useState(false);
    const [rtoModal, setRtoModal] = useState(false);

    const [addState, setAddState] = useState("");
    const [addCity, setAddCity] = useState("");
    const [addRtoCode, setAddRtoCode] = useState("");
    const [addRtoName, setAddRtoName] = useState("");
    const [variantIdInput, setVariantIdInput] = useState('')

    const [pageCount, setPageCount] = useState()
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [totalRecords, setTotalRecords] = useState()
    const [itemOffset, setItemOffset] = useState(1)
        const [sync, setSync] = useState(false);

    const handlePageClick = e => {
        debugger
        const newOffset = e.selected + 1
        setItemOffset(newOffset)
    }



    const [showSidebar, setShowSidebar] = useState(false);


    const [formData, setFormData] = useState({
        prevInsurerName: "",
          sync: false,
    });

    const handleChangeMake = useCallback(
        _.debounce((value) => {
            console.log(value);
        }, 500),
        []
    );

    const handleAddState = (e) => {
        setAddState(e.target.value);
        handleChangeMake(e.target.value);
    };

    const handleAddCity = (e) => {
        setAddCity(e.target.value);
        handleChangeMake(e.target.value);
    };

    const handleAddRto = (e) => {
        setAddRtoCode(e.target.value);
        handleChangeMake(e.target.value);
    };

    const handleAddRtoName = (e) => {
        setAddRtoName(e.target.value);
    };

    // ===========================
    // Submit
    // ===========================
    const handleAddMmv = async () => {
        try {
            setLoading(true);

            const payload = {
                vehicleType: mmvData?.vehicleType || "",

                prevInsurerId: addState || "",
                prevInsurerName: addCity || "",
                Name: addRtoCode || "",
                Digit_Code:addRtoName,
                   sync: sync

            };

            const response = await PostDataWithToken(
                "prev-insurer/addPrevInsurer",
                payload
            );

            if (
                response?.status === "success" ||
                response?.status === true
            ) {
                toast.success(response.message);
            } else {
                toast.error(
                    response?.message
                );
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to add MMV");
        } finally {
            setLoading(false);
        }
    };


    const getPartnerRto = () => {
        setLoading(true)
        let partnerObj = {
            vehicleType: '',
            insurerId: '',
            rtoFullName: "",
             search: variantIdInput,
             limit:itemsPerPage,
             page:itemOffset
        }

        PostDataWithToken('prev-insurer/previous-insurer', partnerObj).then(
            res => {
                setPartnerRtoData(res?.data)
                setPageCount(Math.ceil(res?.totalPages))
                setTotalRecords(res?.totalRecords)
                setLoading(false)
            }
        )
        // setModel(true)
    }

    useEffect(() => {
    getPartnerRto();
}, [itemOffset, itemsPerPage, variantIdInput]);

    const handleChangeItemPerPage = e => {
        setItemsPerPage(e)
    }
    const handleEditClick = (item) => {

     
        setSelectedRto(item);

        setFormData({
            prevInsurerName: item?.prevInsurerName || "",
            sync: sync,
        });

        setShowSidebar(true);
    };
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

const handleUpdateRto = async () => {
    try {
        const response = await PostDataWithToken(
            `/prev-insurer/updatePrevInsurer/${selectedRto?.id}`,
            formData,
            ""
        );

        if (response?.status === true) {
            setShowSidebar(false);

            toast.success(
                response?.message || "RTO updated successfully"
            );

            // Refresh Table Data
            getPartnerRto();
        } else {
            toast.error(
                response?.message || "Failed to update RTO"
            );
        }
    } catch (error) {
        console.error("Update RTO Error:", error);

        toast.error(
            error?.response?.data?.message ||
            "Failed to update RTO"
        );
    }
};
    const handleVariantIdChange = e => {
        setVariantIdInput(e.target.value)
    }
    const [searchType, setSearchType] = useState('search')
    const handleSearch = () => {
        if (searchType === 'search') {
            getPartnerRto('', '','', variantIdInput)
            setSelectedState(null)
            setSelectedCity(null)
            setSelectedRto(null)
        } 
    }
    const handleStatusToggle = async (item) => {
        try {
            setLoading(true);

            const newStatus = !item.isActive;

            const response = await GetDataWithToken(
                `prev-insurer/updatePrevInsurerStatus/${item.id}/status=${newStatus}`
            );

toast.success(response.message);
            // Refresh Data
            getPartnerRto();

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout>
            <div className="container-fluid py-4 dash_main">
                <div className="card">
                    <div className="card-body pt-0 pb-2 d-dlex align-itme-center d-flex justify-content-between">
                        <div className='col-xl-3 col-lg-3 col-md-6 col-12 d-flex align-items-center gao-1'>
                            <div>
                                <label> Search Prev Insurer</label>
                                <div className='mb-3'>
                                    <input
                                        type='search'
                                        placeholder='Search Prev Insurer'
                                        className='form-control'
                                        value={variantIdInput}
                                        onChange={handleVariantIdChange}
                                    />
                                </div>
                            </div>
                            <div
                                className='mt-3 secrch-btn'
                                onClick={() => handleSearch()}
                            >
                                <button>search</button>
                            </div>
                        </div>

                        <div>
                            <button className="btn mt-3 btn-sec" onClick={() => setAddNewRto(!addNewRto)}>Add Prev Insurer</button>
                        </div>

                    </div>

                </div>
                <div className="card mt-3">
                    {addNewRto && (
                        <div className="card-body">

                            <div className="row">

                                {/* STATE */}
                                <div className="col-md-4">
                                            <label>Prev InsurerId</label>
                                        <input
                                            type="text"
                                            className="form-control mt-2"
                                            placeholder="Enter Prev InsurerId"
                                            value={addState}
                                            onChange={handleAddState}
                                        />
                                </div>

                                <div className="col-md-4">
                                            <label>Prev Insure Name</label>
                                        <input
                                            type="text"
                                            className="form-control mt-2"
                                            placeholder="Enter Prev Insurer Name"
                                            value={addCity}
                                            onChange={handleAddCity}
                                        />
                                  
                                </div>

                                {/* RTO */}

                                <div className='col-xl-4 col-lg-4 col-md-6 col-12'>
                                            <label>Name</label>
                                    
                                            <input
                                                type="text"
                                                className="form-control mt-2"
                                                placeholder="Enter Name"
                                                value={addRtoCode}
                                                onChange={handleAddRto}
                                            />
                                </div>

                                {/* RTO NAME */}
                                <div className="col-md-4 mt-3">

                                    <label>Digit Code</label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Digit Code"
                                        value={addRtoName}
                                        onChange={handleAddRtoName}
                                    />
                                </div>

                                  <div className="col-md-4">
                                    <label>Sync</label>
                                    <select
                                        className="form-control mt-2"
                                        value={sync.toString()}
                                        onChange={(e) => setSync(e.target.value === "true")}
                                    >
                                        <option value="">Select Sync</option>
                                        <option value="false">False</option>
                                        <option value="true">True</option>
                                    </select>
                                </div>

                            </div>

                            <div className="d-flex justify-content-end mt-4">
                                <button
                                    className="btn btn-sec"
                                    onClick={handleAddMmv}
                                    disabled={loading}
                                >
                                    {loading ? "Loading..." : "Submit"}
                                </button>
                            </div>

                        </div>
                    )}

                </div>
                <div className='card-body pt-0 pb-2'>
                    <div className='table-responsive p-0'>
                        <table className="table align-items-center mb-0">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Prev Insurer Name</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {partnerRtoData?.length > 0 ? (
                                    partnerRtoData.map((item) => (
                                        <tr key={item.id}>
                                            <td>{item?.id}</td>
                                            <td>{item?.prevInsurerName}</td>
                                  

                                    
                                            <td>
                                                <td>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <div
                                                            className={`custom-switch ${item.isActive ? "active" : ""}`}
                                                            onClick={() => handleStatusToggle(item)}
                                                        >
                                                            <div className="switch-circle"></div>
                                                        </div>

                                                        <span
                                                            className={`fw-semibold ${item?.isActive ? "text-success" : "text-danger"
                                                                }`}
                                                        >

                                                        </span>
                                                    </div>
                                                </td>
                                            </td>

                                            <td>
                                                <button
                                                    type="button"
                                                    className="btn btn-sec btn-sm"
                                                    onClick={() => handleEditClick(item)}
                                                >
                                                    Update
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center">
                                            No Data Found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='card mb-4 p-3'>
                    <div className='d-flex align-items-center justify-content-between flex-wrap'>
                        <div>
                            <p>
                                Showing 1 - {itemsPerPage} items of{' '}
                                {totalRecords}
                            </p>
                        </div>
                        <div className='main-page-item'>
                            <div className='show-page'>
                                <select
                                    className='form-control'
                                    onClick={e =>
                                        handleChangeItemPerPage(e?.target?.value)
                                    }
                                >
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={30}>30</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </div>
                            <div>
                                <ReactPaginate
                                    breakLabel='...'
                                    nextLabel='>'
                                    onPageChange={handlePageClick}
                                    pageRangeDisplayed={5}
                                    pageCount={pageCount}
                                    previousLabel='<'
                                    renderOnZeroPageCount={null}
                                    pageClassName='page-item'
                                    pageLinkClassName='page-link'
                                    previousClassName='page-item'
                                    previousLinkClassName='page-link'
                                    nextClassName='page-item'
                                    nextLinkClassName='page-link'
                                    breakClassName='page-item'
                                    breakLinkClassName='page-link'
                                    containerClassName='pagination'
                                    activeClassName='active'
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {showSidebar && (
                <>
                    <div
                        className="position-fixed top-0 start-0 w-100 h-100"
                        style={{
                            background: "rgba(0,0,0,0.4)",
                            zIndex: 1040,
                        }}
                        onClick={() => setShowSidebar(false)}
                    />

                    <div
                        className="position-fixed top-0 end-0 bg-white shadow"
                        style={{
                            width: "450px",
                            height: "100vh",
                            zIndex: 1050,
                            overflowY: "auto",
                            padding: "20px",
                        }}
                    >
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h4>Edit Prev Insurer</h4>

                            <button
                                className="btn-close"
                                onClick={() => setShowSidebar(false)}
                            />
                        </div>

                        <div className="mb-3">
                            <label>Prev Insurer Name</label>
                            <input
                                type="text"
                                className="form-control"
                                name="prevInsurerName"
                                value={formData.prevInsurerName}
                                onChange={handleChange}
                            />
                        </div>
                           <div className="mb-3">
    <label>Sync</label>
    <select
        className="form-control"
        name="sync"
        value={String(formData.sync)}
        onChange={handleChange}
    >
        <option value="false">False</option>
        <option value="true">True</option>
    </select>
</div>

                       

                        <div className="d-flex gap-2">
                            <button
                                className="btn btn-sec"
                                onClick={handleUpdateRto}
                            >
                                Update
                            </button>

                            <button
                                className="btn btn-secondary"
                                onClick={() => setShowSidebar(false)}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </>
            )}
            {loading && (
                <div className="loader-overlay">
                    <div className="text-center">
                        <div
                            className="spinner-border text-primary"
                            role="status"
                        />
                        <h5 className="mt-3">
                            Updating Status...
                        </h5>
                    </div>
                </div>
            )}
        </Layout>
    );
};

export default AddPrevInsurer;